import { faPrint } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useState } from "react";
import { Button, Form } from "react-bootstrap";
import { trackPromise } from "react-promise-tracker";
import Swal from "sweetalert2";
import "./index.css";
import modeloImpressaoService from "../../../../../../../services/ModeloImpressaoService"; 

export function ItemImpressao({modeloContratual, idTicket}){
  const [itemSelecionado, setItemSelecionado] = useState(null);

  const handleImprimirDocumento = ()=>{
    if(itemSelecionado){
      const modeloSelecionado = modeloContratual.modelos_impressao.find((item) => Number(itemSelecionado) === Number(item.id_modelo_contratual));
      Swal.fire({
        titleText: `Gerar documento?`,
        text: `Tem certeza que deseja geraro o documento "${modeloSelecionado?.nome}"?`,
        icon: "question",
        showCloseButton: false,
        showCancelButton: true,
        focusConfirm: false,
        confirmButtonText: "Sim, gerar!",
        cancelButtonText: "Cancelar",
        customClass: {
          confirmButton: "btn btn-primary mr-3",
          cancelButton: "btn btn-secondary mr-3",
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.isConfirmed) {
          trackPromise(modeloImpressaoService.getModeloImpressao(idTicket, itemSelecionado)).then((response)=>{
            if(response?.data?.length){
              window.open(response.data, '_blank');
            }else{
              Swal.fire({
                title: 'Ooops...',
                text: 'Não foi possível gerar o documento. Favor entrar em contato com suporte.',
                icon: 'warning',
              }) 
            }
          }).catch((error)=>{
            Swal.fire({
              title: 'Ooops...',
              text: 'Ocorreu um erro ao gerar o documento.',
              icon: 'error',
            }) 
          })
        }
      })
    }
  }

  return(
    <div className="item-impressao">
      <Form.Group controlId="exampleForm.ControlSelect1">
        <Form.Label>{modeloContratual.descricao}</Form.Label>
        <Form.Control 
          as="select"
          onChange={(e)=>{
            setItemSelecionado(e.target.value);
          }}
        >
          <option value="">Selecione</option>
          {modeloContratual?.modelos_impressao.map((item, index)=>{
            return(
              <option key={index} value={item.id_modelo_contratual}>{item.nome}</option>
            )
          })}
        </Form.Control>
      </Form.Group>
      <Button 
        className="btn-imprimir" 
        variant="secondary"
        onClick={()=>{
          handleImprimirDocumento();
        }}
        disabled={!itemSelecionado}
      >
        <FontAwesomeIcon icon={faPrint}/>
        Gerar
      </Button>
    </div>
  )
}
